/**
 * Ponto de registro do quadro `wing_show` de cada asa: onde o canto superior esquerdo da imagem fica, em px, em relação à origem do símbolo no
 * `wings.swf` do legado. O atlas não guarda esse ponto (o quadro vem aparado). Gerado dos SWF (soma das formas do símbolo `wing_show_<id>`,
 * com as matrizes de posição), por asa: `[x0, y0]`. A largura e a altura da imagem vêm do próprio quadro.
 */
export const WING_SHOW_ORIGIN: Readonly<Record<string, readonly [number, number]>> = {
  wing002: [-22.33, 77.6],
  wing003: [-22.33, 77.6],
  wing004: [-22.33, 77.6],
  wing005: [-22.33, 77.6],
  wing006: [-22.33, 77.6],
  wing007: [-22.33, 77.6],
  wing008: [-22.33, 77.6],
  wing009: [-22.33, 77.6],
  wing018: [-22.87, 76.33],
  wing019: [-43.49, 69.4],
  wing020: [-23.25, 64.45],
  wing021: [-23.25, 65.45],
  wing022: [-23.25, 64.45],
  wing023: [-23.25, 64.45],
  wing024: [-22.35, 10.28],
  wing025: [-28.3, 43.37],
  wing026: [-23.66, 10.28],
  wing027: [-14.48, 67.82],
  wing028: [-14.48, 67.57],
  wing029: [-14.48, 67.57],
  wing030: [-33.57, 53.15],
  wing043: [-49.9, -4.4],
  wing31: [-24.22, 41.29],
  wing32: [-24.22, 41.29],
  wing33: [-24.22, 41.29],
  wing34: [-24.22, 41.29],
  wing35: [-24, -13.46],
  wing36: [78.35, 94.69],
  wing37: [58.16, -16.95],
  wing38: [61.35, 53.55],
  wing39: [-7.59, -21.3],
  wing40: [63.27, -34.45],
  wing41: [-16.98, 6.5],
  wing42: [-32.54, -21.79],
};
